import { useEffect } from "react";
import { CONNECTOR_USAGE_MONITORING_FLAG } from "../../../shared/featureFlagNames";
import { useFeatureFlag } from "../../hooks/useFeatureFlag";
import { navigate, Route, routes, Switch, useRouteMatch } from "../../lib/urls";
import { AccessMap } from "../Settings/AccessGraph";
import { AI } from "./AI";
import { Connectors } from "./Connectors";
import { Value } from "./Value";
import { Workflows } from "./Workflows";

export function Monitoring() {
  const connectorMonitoring =
    useFeatureFlag(CONNECTOR_USAGE_MONITORING_FLAG) === true;
  return (
    <Switch>
      <Route path={routes.monitoring.value}>
        <Value />
      </Route>
      <Route path={routes.monitoring.workflows}>
        <Workflows />
      </Route>
      <Route path={routes.monitoring.access}>
        <AccessMap />
      </Route>
      <Route path={routes.monitoring.ai}>
        <AI />
      </Route>
      {connectorMonitoring && (
        <Route path={routes.monitoring.connectors}>
          <Connectors />
        </Route>
      )}
      <Route path={routes.monitoring}>
        <RedirectToWorkflows connectorMonitoring={connectorMonitoring} />
      </Route>
    </Switch>
  );
}

function RedirectToWorkflows({
  connectorMonitoring,
}: {
  connectorMonitoring: boolean;
}) {
  const [isValue] = useRouteMatch(routes.monitoring.value);
  const [isWorkflows] = useRouteMatch(routes.monitoring.workflows);
  const [isAccess] = useRouteMatch(routes.monitoring.access);
  const [isAI] = useRouteMatch(routes.monitoring.ai);
  const [isConnectors] = useRouteMatch(routes.monitoring.connectors);

  useEffect(() => {
    if (
      !isValue &&
      !isWorkflows &&
      !isAccess &&
      !isAI &&
      !(isConnectors && connectorMonitoring)
    ) {
      navigate(routes.monitoring.workflows, undefined, { replace: true });
    }
  }, [isValue, isWorkflows, isAccess, isAI, isConnectors, connectorMonitoring]);

  return null;
}
